import * as React from 'react';
export const usdpSvg = React.forwardRef(function usdpSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00A64F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_usdp__a)',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_usdp__b)',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_usdp__c)',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M18.552 14.941h-1.204v-3.475h5.234V9.332h-5.234V6h-2.696v3.348h-1.14C11.056 9.348 9 10.57 9 13.249c0 2.339 1.802 3.81 4.448 3.81h1.204v3.475H9.418v2.133h5.234V26h2.696v-3.348h1.14c2.465 0 4.512-1.222 4.512-3.902 0-2.338-1.802-3.809-4.448-3.809Zm-3.9 2.118v-2.118h-.858c-1.146 0-2.076-.476-2.076-1.741 0-1.251.886-1.727 2.134-1.727h.8v3.475h2.696v2.118l-2.696-.007Zm3.496 3.475h-.8V17.06h.858c1.146 0 2.076.476 2.076 1.741 0 1.258-.887 1.734-2.134 1.734Z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_usdp__a',
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'translate(1.4 24.873) scale(25.5985)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.09,
          stopColor: '#00522C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00522C',
          stopOpacity: 0,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_usdp__b',
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'rotate(-97.18 26.27 2.947) scale(25.5996)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.09,
          stopColor: '#00A64F',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00A64F',
          stopOpacity: 0,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_usdp__c',
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'translate(30.836 5.61) scale(21.254)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.098,
          stopColor: '#8AD137',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#8AD137',
          stopOpacity: 0,
        }),
      ),
    ),
  );
});
usdpSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usdp = {
  category: 'brand',
  colorable: false,
  name: 'usdp',
  svg: usdpSvg,
};
